import { useState } from 'react'
import image1 from './images/1.jpg'
import image2 from './images/2.jpg'
import image3 from './images/3.jpg'
import image4 from './images/4.jpg'
import image5 from './images/5.jpg'
import image6 from './images/6.jpg'
import image7 from './images/7.jpg'
import image8 from './images/8.jpg'

export const GallerySection: React.FC = () => {
  const photos = [
    { src: image1, alt: '枝ものを飾ったインテリア 1' },
    { src: image2, alt: '枝ものを飾ったインテリア 2' },
    { src: image3, alt: '枝ものを飾ったインテリア 3' },
    { src: image4, alt: '枝ものを飾ったインテリア 4' },
    { src: image5, alt: '枝ものを飾ったインテリア 5' },
    { src: image6, alt: '枝ものを飾ったインテリア 6' },
    { src: image7, alt: '枝ものを飾ったインテリア 7' },
    { src: image8, alt: '枝ものを飾ったインテリア 8' },
  ]

  return (
    <section className="py-16 md:py-24 overflow-hidden">
      <p className="px-5 text-center text-2xl md:text-3xl font-medium text-black mb-14">#枝もののある暮らし</p>
      <div
        className="flex gap-3 pl-5 select-none gallery-scroll"
        style={{ width: 'max-content' }}
      >
        {[...photos, ...photos].map((p, i) => (
          <div key={i} className="shrink-0 w-[72vw] md:w-[28vw] aspect-3/4 rounded-2xl overflow-hidden bg-gray/30">
            <img src={p.src} alt={p.alt} className="w-full h-full object-cover" />
          </div>
        ))}
      </div>
    </section>
  )
}
